module.exports = __webpack_public_path__ + "static/img/22.a4311c49.png";